import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, AppointmentCoachRole, AppointmentCoachRoleWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAppointmentCoachRole(): UseMutationResult<
  AxiosResponse<AppointmentCoachRole>,
  AxiosError<ErrorMessage>,
  AppointmentCoachRoleWrite
> {
  const queryClient = useQueryClient();

  const updateAppointmentCoachRole = (
    payload: AppointmentCoachRoleWrite,
  ): Promise<AxiosResponse<AppointmentCoachRole>> => {
    return client.put(`appointment-coach-roles/${payload?.appointmentCoachRoleId}/`, payload);
  };

  return useMutation(updateAppointmentCoachRole, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['appointmentCoachRoles'],
      });
      queryClient.invalidateQueries({
        queryKey: ['appointmentPayRateLookups'],
      });
    },
  });
}
